import productListReducer from "@store/Framework/Store/Store/Pages/ProductList/ProductListReducer";
import { combineReducers } from "redux";

const pagesReducers = {
    productList: productListReducer,
};

export type PagesReducers = typeof pagesReducers;

const pagesReducer = combineReducers(pagesReducers as any);
export default pagesReducer;
